/** Obtiene límites inclusivos sin parsear fechas locales como UTC. */
export const materialPeriod = (period) => {
  const now = new Date();
  const today = new Date(
    now.toLocaleString('en-US', { timeZone: 'America/Argentina/Buenos_Aires' })
  );
  const date = (value) => {
    const month = String(value.getMonth() + 1).padStart(2, '0');
    const day = String(value.getDate()).padStart(2, '0');
    return `${value.getFullYear()}-${month}-${day}`;
  };
  if (period === 'all') return { date_from: '', date_to: '' };
  let from = new Date(today);
  let to = new Date(today);
  if (period === 'month') {
    from.setDate(1);
  } else if (period === 'previous') {
    from = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    to = new Date(today.getFullYear(), today.getMonth(), 0);
  } else {
    from.setDate(from.getDate() - Number(period) + 1);
  }
  return { date_from: date(from), date_to: date(to) };
};
